import { render } from "./correos-adeudos.vue?vue&type=template&id=4594acb6&scoped=true"
import script from "./correos-adeudos.vue?vue&type=script&lang=js"
export * from "./correos-adeudos.vue?vue&type=script&lang=js"

import "./correos-adeudos.vue?vue&type=style&index=0&id=4594acb6&scoped=true&lang=css"
import "./correos-adeudos.vue?vue&type=style&index=1&id=4594acb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4594acb6"]])

export default __exports__